// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive margin for cardRoot (assessment-initiation): when viewport width > 1350px */
@media (min-width: 1550px) {
  .assessment-initiation {
    margin-top: 80px !important;
  }
}

/* Subtitle: when viewport width > 1550px */
@media (min-width: 1551px) {
  .assessment-initiation-subtitle {
    margin: 20px 0 44px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/AssessmentInitiation.cardRoot.css"],"names":[],"mappings":"AAAA,yFAAyF;AACzF;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,qBAAqB;EACvB;AACF","sourcesContent":["/* Responsive margin for cardRoot (assessment-initiation): when viewport width > 1350px */\n@media (min-width: 1550px) {\n  .assessment-initiation {\n    margin-top: 80px !important;\n  }\n}\n\n/* Subtitle: when viewport width > 1550px */\n@media (min-width: 1551px) {\n  .assessment-initiation-subtitle {\n    margin: 20px 0 44px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
